/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CustomerRouteImport } from './routes/_customer'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PortalSlugRouteImport } from './routes/portal/$slug'
import { Route as PortalSlugIndexRouteImport } from './routes/portal/$slug/index'
import { Route as CustomerPropertiesIndexRouteImport } from './routes/_customer/properties/index'
import { Route as CustomerLettersIndexRouteImport } from './routes/_customer/letters/index'
import { Route as CustomerHomeIndexRouteImport } from './routes/_customer/home/index'
import { Route as CustomerAccountIndexRouteImport } from './routes/_customer/account/index'
import { Route as PortalSlugResetPasswordRouteImport } from './routes/portal/$slug/reset-password'
import { Route as PortalSlugForgotPasswordRouteImport } from './routes/portal/$slug/forgot-password'
import { Route as PortalSlugAcceptInviteRouteImport } from './routes/portal/$slug/accept-invite'
import { Route as CustomerLettersNoticeIdRouteImport } from './routes/_customer/letters/$noticeId'
import { Route as CustomerTestingRequestsIndexRouteImport } from './routes/_customer/testing/requests/index'
import { Route as CustomerTestingRequestIndexRouteImport } from './routes/_customer/testing/request/index'
import { Route as CustomerTestingHistoryIndexRouteImport } from './routes/_customer/testing/history/index'
import { Route as CustomerPropertiesFacilityIdIndexRouteImport } from './routes/_customer/properties/$facilityId/index'
import { Route as CustomerLettersIssuesIndexRouteImport } from './routes/_customer/letters/issues/index'
import { Route as CustomerTestingRequestsRequestIdRouteImport } from './routes/_customer/testing/requests/$requestId'
import { Route as CustomerTestingHistorySubmissionIdRouteImport } from './routes/_customer/testing/history/$submissionId'
import { Route as CustomerPropertiesDevicesInstallationIdRouteImport } from './routes/_customer/properties/devices/$installationId'
import { Route as CustomerLettersIssuesViolationIdRouteImport } from './routes/_customer/letters/issues/$violationId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CustomerRoute = CustomerRouteImport.update({
  id: '/_customer',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalSlugRoute = PortalSlugRouteImport.update({
  id: '/portal/$slug',
  path: '/portal/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalSlugIndexRoute = PortalSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalSlugRoute,
} as any)
const CustomerPropertiesIndexRoute = CustomerPropertiesIndexRouteImport.update({
  id: '/properties/',
  path: '/properties/',
  getParentRoute: () => CustomerRoute,
} as any)
const CustomerLettersIndexRoute = CustomerLettersIndexRouteImport.update({
  id: '/letters/',
  path: '/letters/',
  getParentRoute: () => CustomerRoute,
} as any)
const CustomerHomeIndexRoute = CustomerHomeIndexRouteImport.update({
  id: '/home/',
  path: '/home/',
  getParentRoute: () => CustomerRoute,
} as any)
const CustomerAccountIndexRoute = CustomerAccountIndexRouteImport.update({
  id: '/account/',
  path: '/account/',
  getParentRoute: () => CustomerRoute,
} as any)
const PortalSlugResetPasswordRoute = PortalSlugResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => PortalSlugRoute,
} as any)
const PortalSlugForgotPasswordRoute =
  PortalSlugForgotPasswordRouteImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => PortalSlugRoute,
  } as any)
const PortalSlugAcceptInviteRoute = PortalSlugAcceptInviteRouteImport.update({
  id: '/accept-invite',
  path: '/accept-invite',
  getParentRoute: () => PortalSlugRoute,
} as any)
const CustomerLettersNoticeIdRoute = CustomerLettersNoticeIdRouteImport.update({
  id: '/letters/$noticeId',
  path: '/letters/$noticeId',
  getParentRoute: () => CustomerRoute,
} as any)
const CustomerTestingRequestsIndexRoute =
  CustomerTestingRequestsIndexRouteImport.update({
    id: '/testing/requests/',
    path: '/testing/requests/',
    getParentRoute: () => CustomerRoute,
  } as any)
const CustomerTestingRequestIndexRoute =
  CustomerTestingRequestIndexRouteImport.update({
    id: '/testing/request/',
    path: '/testing/request/',
    getParentRoute: () => CustomerRoute,
  } as any)
const CustomerTestingHistoryIndexRoute =
  CustomerTestingHistoryIndexRouteImport.update({
    id: '/testing/history/',
    path: '/testing/history/',
    getParentRoute: () => CustomerRoute,
  } as any)
const CustomerPropertiesFacilityIdIndexRoute =
  CustomerPropertiesFacilityIdIndexRouteImport.update({
    id: '/properties/$facilityId/',
    path: '/properties/$facilityId/',
    getParentRoute: () => CustomerRoute,
  } as any)
const CustomerLettersIssuesIndexRoute =
  CustomerLettersIssuesIndexRouteImport.update({
    id: '/letters/issues/',
    path: '/letters/issues/',
    getParentRoute: () => CustomerRoute,
  } as any)
const CustomerTestingRequestsRequestIdRoute =
  CustomerTestingRequestsRequestIdRouteImport.update({
    id: '/testing/requests/$requestId',
    path: '/testing/requests/$requestId',
    getParentRoute: () => CustomerRoute,
  } as any)
const CustomerTestingHistorySubmissionIdRoute =
  CustomerTestingHistorySubmissionIdRouteImport.update({
    id: '/testing/history/$submissionId',
    path: '/testing/history/$submissionId',
    getParentRoute: () => CustomerRoute,
  } as any)
const CustomerPropertiesDevicesInstallationIdRoute =
  CustomerPropertiesDevicesInstallationIdRouteImport.update({
    id: '/properties/devices/$installationId',
    path: '/properties/devices/$installationId',
    getParentRoute: () => CustomerRoute,
  } as any)
const CustomerLettersIssuesViolationIdRoute =
  CustomerLettersIssuesViolationIdRouteImport.update({
    id: '/letters/issues/$violationId',
    path: '/letters/issues/$violationId',
    getParentRoute: () => CustomerRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/portal/$slug': typeof PortalSlugRouteWithChildren
  '/letters/$noticeId': typeof CustomerLettersNoticeIdRoute
  '/portal/$slug/accept-invite': typeof PortalSlugAcceptInviteRoute
  '/portal/$slug/forgot-password': typeof PortalSlugForgotPasswordRoute
  '/portal/$slug/reset-password': typeof PortalSlugResetPasswordRoute
  '/account/': typeof CustomerAccountIndexRoute
  '/home/': typeof CustomerHomeIndexRoute
  '/letters/': typeof CustomerLettersIndexRoute
  '/properties/': typeof CustomerPropertiesIndexRoute
  '/portal/$slug/': typeof PortalSlugIndexRoute
  '/letters/issues/$violationId': typeof CustomerLettersIssuesViolationIdRoute
  '/properties/devices/$installationId': typeof CustomerPropertiesDevicesInstallationIdRoute
  '/testing/history/$submissionId': typeof CustomerTestingHistorySubmissionIdRoute
  '/testing/requests/$requestId': typeof CustomerTestingRequestsRequestIdRoute
  '/letters/issues/': typeof CustomerLettersIssuesIndexRoute
  '/properties/$facilityId/': typeof CustomerPropertiesFacilityIdIndexRoute
  '/testing/history/': typeof CustomerTestingHistoryIndexRoute
  '/testing/request/': typeof CustomerTestingRequestIndexRoute
  '/testing/requests/': typeof CustomerTestingRequestsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/letters/$noticeId': typeof CustomerLettersNoticeIdRoute
  '/portal/$slug/accept-invite': typeof PortalSlugAcceptInviteRoute
  '/portal/$slug/forgot-password': typeof PortalSlugForgotPasswordRoute
  '/portal/$slug/reset-password': typeof PortalSlugResetPasswordRoute
  '/account': typeof CustomerAccountIndexRoute
  '/home': typeof CustomerHomeIndexRoute
  '/letters': typeof CustomerLettersIndexRoute
  '/properties': typeof CustomerPropertiesIndexRoute
  '/portal/$slug': typeof PortalSlugIndexRoute
  '/letters/issues/$violationId': typeof CustomerLettersIssuesViolationIdRoute
  '/properties/devices/$installationId': typeof CustomerPropertiesDevicesInstallationIdRoute
  '/testing/history/$submissionId': typeof CustomerTestingHistorySubmissionIdRoute
  '/testing/requests/$requestId': typeof CustomerTestingRequestsRequestIdRoute
  '/letters/issues': typeof CustomerLettersIssuesIndexRoute
  '/properties/$facilityId': typeof CustomerPropertiesFacilityIdIndexRoute
  '/testing/history': typeof CustomerTestingHistoryIndexRoute
  '/testing/request': typeof CustomerTestingRequestIndexRoute
  '/testing/requests': typeof CustomerTestingRequestsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_customer': typeof CustomerRouteWithChildren
  '/login': typeof LoginRoute
  '/portal/$slug': typeof PortalSlugRouteWithChildren
  '/_customer/letters/$noticeId': typeof CustomerLettersNoticeIdRoute
  '/portal/$slug/accept-invite': typeof PortalSlugAcceptInviteRoute
  '/portal/$slug/forgot-password': typeof PortalSlugForgotPasswordRoute
  '/portal/$slug/reset-password': typeof PortalSlugResetPasswordRoute
  '/_customer/account/': typeof CustomerAccountIndexRoute
  '/_customer/home/': typeof CustomerHomeIndexRoute
  '/_customer/letters/': typeof CustomerLettersIndexRoute
  '/_customer/properties/': typeof CustomerPropertiesIndexRoute
  '/portal/$slug/': typeof PortalSlugIndexRoute
  '/_customer/letters/issues/$violationId': typeof CustomerLettersIssuesViolationIdRoute
  '/_customer/properties/devices/$installationId': typeof CustomerPropertiesDevicesInstallationIdRoute
  '/_customer/testing/history/$submissionId': typeof CustomerTestingHistorySubmissionIdRoute
  '/_customer/testing/requests/$requestId': typeof CustomerTestingRequestsRequestIdRoute
  '/_customer/letters/issues/': typeof CustomerLettersIssuesIndexRoute
  '/_customer/properties/$facilityId/': typeof CustomerPropertiesFacilityIdIndexRoute
  '/_customer/testing/history/': typeof CustomerTestingHistoryIndexRoute
  '/_customer/testing/request/': typeof CustomerTestingRequestIndexRoute
  '/_customer/testing/requests/': typeof CustomerTestingRequestsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/portal/$slug'
    | '/letters/$noticeId'
    | '/portal/$slug/accept-invite'
    | '/portal/$slug/forgot-password'
    | '/portal/$slug/reset-password'
    | '/account/'
    | '/home/'
    | '/letters/'
    | '/properties/'
    | '/portal/$slug/'
    | '/letters/issues/$violationId'
    | '/properties/devices/$installationId'
    | '/testing/history/$submissionId'
    | '/testing/requests/$requestId'
    | '/letters/issues/'
    | '/properties/$facilityId/'
    | '/testing/history/'
    | '/testing/request/'
    | '/testing/requests/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/letters/$noticeId'
    | '/portal/$slug/accept-invite'
    | '/portal/$slug/forgot-password'
    | '/portal/$slug/reset-password'
    | '/account'
    | '/home'
    | '/letters'
    | '/properties'
    | '/portal/$slug'
    | '/letters/issues/$violationId'
    | '/properties/devices/$installationId'
    | '/testing/history/$submissionId'
    | '/testing/requests/$requestId'
    | '/letters/issues'
    | '/properties/$facilityId'
    | '/testing/history'
    | '/testing/request'
    | '/testing/requests'
  id:
    | '__root__'
    | '/'
    | '/_customer'
    | '/login'
    | '/portal/$slug'
    | '/_customer/letters/$noticeId'
    | '/portal/$slug/accept-invite'
    | '/portal/$slug/forgot-password'
    | '/portal/$slug/reset-password'
    | '/_customer/account/'
    | '/_customer/home/'
    | '/_customer/letters/'
    | '/_customer/properties/'
    | '/portal/$slug/'
    | '/_customer/letters/issues/$violationId'
    | '/_customer/properties/devices/$installationId'
    | '/_customer/testing/history/$submissionId'
    | '/_customer/testing/requests/$requestId'
    | '/_customer/letters/issues/'
    | '/_customer/properties/$facilityId/'
    | '/_customer/testing/history/'
    | '/_customer/testing/request/'
    | '/_customer/testing/requests/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CustomerRoute: typeof CustomerRouteWithChildren
  LoginRoute: typeof LoginRoute
  PortalSlugRoute: typeof PortalSlugRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_customer': {
      id: '/_customer'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof CustomerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/$slug': {
      id: '/portal/$slug'
      path: '/portal/$slug'
      fullPath: '/portal/$slug'
      preLoaderRoute: typeof PortalSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/$slug/': {
      id: '/portal/$slug/'
      path: '/'
      fullPath: '/portal/$slug/'
      preLoaderRoute: typeof PortalSlugIndexRouteImport
      parentRoute: typeof PortalSlugRoute
    }
    '/_customer/properties/': {
      id: '/_customer/properties/'
      path: '/properties'
      fullPath: '/properties/'
      preLoaderRoute: typeof CustomerPropertiesIndexRouteImport
      parentRoute: typeof CustomerRoute
    }
    '/_customer/letters/': {
      id: '/_customer/letters/'
      path: '/letters'
      fullPath: '/letters/'
      preLoaderRoute: typeof CustomerLettersIndexRouteImport
      parentRoute: typeof CustomerRoute
    }
    '/_customer/home/': {
      id: '/_customer/home/'
      path: '/home'
      fullPath: '/home/'
      preLoaderRoute: typeof CustomerHomeIndexRouteImport
      parentRoute: typeof CustomerRoute
    }
    '/_customer/account/': {
      id: '/_customer/account/'
      path: '/account'
      fullPath: '/account/'
      preLoaderRoute: typeof CustomerAccountIndexRouteImport
      parentRoute: typeof CustomerRoute
    }
    '/portal/$slug/reset-password': {
      id: '/portal/$slug/reset-password'
      path: '/reset-password'
      fullPath: '/portal/$slug/reset-password'
      preLoaderRoute: typeof PortalSlugResetPasswordRouteImport
      parentRoute: typeof PortalSlugRoute
    }
    '/portal/$slug/forgot-password': {
      id: '/portal/$slug/forgot-password'
      path: '/forgot-password'
      fullPath: '/portal/$slug/forgot-password'
      preLoaderRoute: typeof PortalSlugForgotPasswordRouteImport
      parentRoute: typeof PortalSlugRoute
    }
    '/portal/$slug/accept-invite': {
      id: '/portal/$slug/accept-invite'
      path: '/accept-invite'
      fullPath: '/portal/$slug/accept-invite'
      preLoaderRoute: typeof PortalSlugAcceptInviteRouteImport
      parentRoute: typeof PortalSlugRoute
    }
    '/_customer/letters/$noticeId': {
      id: '/_customer/letters/$noticeId'
      path: '/letters/$noticeId'
      fullPath: '/letters/$noticeId'
      preLoaderRoute: typeof CustomerLettersNoticeIdRouteImport
      parentRoute: typeof CustomerRoute
    }
    '/_customer/testing/requests/': {
      id: '/_customer/testing/requests/'
      path: '/testing/requests'
      fullPath: '/testing/requests/'
      preLoaderRoute: typeof CustomerTestingRequestsIndexRouteImport
      parentRoute: typeof CustomerRoute
    }
    '/_customer/testing/request/': {
      id: '/_customer/testing/request/'
      path: '/testing/request'
      fullPath: '/testing/request/'
      preLoaderRoute: typeof CustomerTestingRequestIndexRouteImport
      parentRoute: typeof CustomerRoute
    }
    '/_customer/testing/history/': {
      id: '/_customer/testing/history/'
      path: '/testing/history'
      fullPath: '/testing/history/'
      preLoaderRoute: typeof CustomerTestingHistoryIndexRouteImport
      parentRoute: typeof CustomerRoute
    }
    '/_customer/properties/$facilityId/': {
      id: '/_customer/properties/$facilityId/'
      path: '/properties/$facilityId'
      fullPath: '/properties/$facilityId/'
      preLoaderRoute: typeof CustomerPropertiesFacilityIdIndexRouteImport
      parentRoute: typeof CustomerRoute
    }
    '/_customer/letters/issues/': {
      id: '/_customer/letters/issues/'
      path: '/letters/issues'
      fullPath: '/letters/issues/'
      preLoaderRoute: typeof CustomerLettersIssuesIndexRouteImport
      parentRoute: typeof CustomerRoute
    }
    '/_customer/testing/requests/$requestId': {
      id: '/_customer/testing/requests/$requestId'
      path: '/testing/requests/$requestId'
      fullPath: '/testing/requests/$requestId'
      preLoaderRoute: typeof CustomerTestingRequestsRequestIdRouteImport
      parentRoute: typeof CustomerRoute
    }
    '/_customer/testing/history/$submissionId': {
      id: '/_customer/testing/history/$submissionId'
      path: '/testing/history/$submissionId'
      fullPath: '/testing/history/$submissionId'
      preLoaderRoute: typeof CustomerTestingHistorySubmissionIdRouteImport
      parentRoute: typeof CustomerRoute
    }
    '/_customer/properties/devices/$installationId': {
      id: '/_customer/properties/devices/$installationId'
      path: '/properties/devices/$installationId'
      fullPath: '/properties/devices/$installationId'
      preLoaderRoute: typeof CustomerPropertiesDevicesInstallationIdRouteImport
      parentRoute: typeof CustomerRoute
    }
    '/_customer/letters/issues/$violationId': {
      id: '/_customer/letters/issues/$violationId'
      path: '/letters/issues/$violationId'
      fullPath: '/letters/issues/$violationId'
      preLoaderRoute: typeof CustomerLettersIssuesViolationIdRouteImport
      parentRoute: typeof CustomerRoute
    }
  }
}

interface CustomerRouteChildren {
  CustomerLettersNoticeIdRoute: typeof CustomerLettersNoticeIdRoute
  CustomerAccountIndexRoute: typeof CustomerAccountIndexRoute
  CustomerHomeIndexRoute: typeof CustomerHomeIndexRoute
  CustomerLettersIndexRoute: typeof CustomerLettersIndexRoute
  CustomerPropertiesIndexRoute: typeof CustomerPropertiesIndexRoute
  CustomerLettersIssuesViolationIdRoute: typeof CustomerLettersIssuesViolationIdRoute
  CustomerPropertiesDevicesInstallationIdRoute: typeof CustomerPropertiesDevicesInstallationIdRoute
  CustomerTestingHistorySubmissionIdRoute: typeof CustomerTestingHistorySubmissionIdRoute
  CustomerTestingRequestsRequestIdRoute: typeof CustomerTestingRequestsRequestIdRoute
  CustomerLettersIssuesIndexRoute: typeof CustomerLettersIssuesIndexRoute
  CustomerPropertiesFacilityIdIndexRoute: typeof CustomerPropertiesFacilityIdIndexRoute
  CustomerTestingHistoryIndexRoute: typeof CustomerTestingHistoryIndexRoute
  CustomerTestingRequestIndexRoute: typeof CustomerTestingRequestIndexRoute
  CustomerTestingRequestsIndexRoute: typeof CustomerTestingRequestsIndexRoute
}

const CustomerRouteChildren: CustomerRouteChildren = {
  CustomerLettersNoticeIdRoute: CustomerLettersNoticeIdRoute,
  CustomerAccountIndexRoute: CustomerAccountIndexRoute,
  CustomerHomeIndexRoute: CustomerHomeIndexRoute,
  CustomerLettersIndexRoute: CustomerLettersIndexRoute,
  CustomerPropertiesIndexRoute: CustomerPropertiesIndexRoute,
  CustomerLettersIssuesViolationIdRoute: CustomerLettersIssuesViolationIdRoute,
  CustomerPropertiesDevicesInstallationIdRoute:
    CustomerPropertiesDevicesInstallationIdRoute,
  CustomerTestingHistorySubmissionIdRoute:
    CustomerTestingHistorySubmissionIdRoute,
  CustomerTestingRequestsRequestIdRoute: CustomerTestingRequestsRequestIdRoute,
  CustomerLettersIssuesIndexRoute: CustomerLettersIssuesIndexRoute,
  CustomerPropertiesFacilityIdIndexRoute:
    CustomerPropertiesFacilityIdIndexRoute,
  CustomerTestingHistoryIndexRoute: CustomerTestingHistoryIndexRoute,
  CustomerTestingRequestIndexRoute: CustomerTestingRequestIndexRoute,
  CustomerTestingRequestsIndexRoute: CustomerTestingRequestsIndexRoute,
}

const CustomerRouteWithChildren = CustomerRoute._addFileChildren(
  CustomerRouteChildren,
)

interface PortalSlugRouteChildren {
  PortalSlugAcceptInviteRoute: typeof PortalSlugAcceptInviteRoute
  PortalSlugForgotPasswordRoute: typeof PortalSlugForgotPasswordRoute
  PortalSlugResetPasswordRoute: typeof PortalSlugResetPasswordRoute
  PortalSlugIndexRoute: typeof PortalSlugIndexRoute
}

const PortalSlugRouteChildren: PortalSlugRouteChildren = {
  PortalSlugAcceptInviteRoute: PortalSlugAcceptInviteRoute,
  PortalSlugForgotPasswordRoute: PortalSlugForgotPasswordRoute,
  PortalSlugResetPasswordRoute: PortalSlugResetPasswordRoute,
  PortalSlugIndexRoute: PortalSlugIndexRoute,
}

const PortalSlugRouteWithChildren = PortalSlugRoute._addFileChildren(
  PortalSlugRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CustomerRoute: CustomerRouteWithChildren,
  LoginRoute: LoginRoute,
  PortalSlugRoute: PortalSlugRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
